import styled from 'styled-components';

export const Image = styled.div`
  img{
    height: 560px;;
  }
`